// Permission constants for this module
export const PERMISSIONS = {
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  APPROVE: 'approve',
  SEND: 'send',
  WHATSAPP: 'whatsapp'
};

// Status configuration - 6 confirmed statuses
// Flow: pending -> draft -> sent -> paid (or overdue/void)
export const STATUS_CONFIG: Record<string, { label: string; color: string; bg: string; icon: string }> = {
  pending: { label: 'Pending', color: 'var(--color-warning)', bg: 'var(--color-warning-bg)', icon: '⏳' },
  draft: { label: 'Draft', color: 'var(--color-text-light)', bg: 'var(--color-bg)', icon: '📝' },
  sent: { label: 'Sent', color: 'var(--color-info)', bg: 'var(--color-info-bg)', icon: '📤' },
  overdue: { label: 'Overdue', color: 'var(--color-error)', bg: 'var(--color-error-bg)', icon: '⚠️' },
  paid: { label: 'Paid', color: 'var(--color-success)', bg: 'var(--color-success-bg)', icon: '✅' },
  void: { label: 'Void', color: 'var(--color-text-light)', bg: 'var(--color-border)', icon: '🚫' },
};

// Workflow columns for Kanban board
export const WORKFLOW_COLUMNS = [
  { id: 'pending', label: 'Pending' },
  { id: 'draft', label: 'Draft' },
  { id: 'sent', label: 'Sent' },
  { id: 'overdue', label: 'Overdue' },
  { id: 'paid', label: 'Paid' },
];
